import React from "react";
import ReactPlayer from "react-player";

const VideoPreview = ({ url }) => {
  if (!url) return null;

  const isYouTube = ReactPlayer.canPlay(url) && (url.includes("youtube.com") || url.includes("youtu.be"));
  const isInstagram = url.includes("instagram.com");

  const getInstagramEmbedUrl = (link) => {
    try {
      const urlObj = new URL(link);
      const pathSegments = urlObj.pathname.split("/").filter(Boolean);
      const type = pathSegments[0]; // 'p', 'reel', or 'tv'
      const postId = pathSegments[1];

      if (!["p", "reel", "tv"].includes(type) || !postId) return null;
      return `https://www.instagram.com/${type}/${postId}/embed`;
    } catch {
      return null;
    }
  };

  return (
    <div className="flex flex-col gap-4 w-full max-w-xl lg:max-w-2xl">
      {isYouTube && (
        <div className="aspect-video w-full">
          <ReactPlayer
            url={url}
            controls
            width="100%"
            height="100%"
          />
        </div>
      )}

      {isInstagram && (
        <div className="w-full">
          <iframe
            src={getInstagramEmbedUrl(url)}
            className="w-full min-h-[400px] md:h-[650px] border-none"
            title="Instagram preview"
            scrolling="no"
            allow="encrypted-media; picture-in-picture"
            allowFullScreen
          />
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-sm text-primary underline mt-2 text-right"
          >
            Watch on Instagram
          </a>
        </div>
      )}
    </div>
  );
};

export default VideoPreview;